/**
 * Beschriftung einer Zahlung fuer den GAST (Pendant zu apps/api/src/lib/zahlungsart-label.ts,
 * gleiche Regel, gleiche Tests). `payment_type='deposit'` ist technisch auch dann gesetzt, wenn
 * 100 % bei Buchung faellig sind - der Gast sieht dann "Zahlung", nicht "Anzahlung". Reine
 * Beschriftung: Typ, Betrag und Status bleiben unveraendert. Ohne bekannte Gesamtsumme bleibt
 * es beim Typ-Label.
 */
export function deckteGesamtbetrag(amountCents: number | null | undefined, totalCents: number | null | undefined): boolean {
  return typeof amountCents === "number" && typeof totalCents === "number" && totalCents > 0 && amountCents >= totalCents;
}

const LABEL: Record<string, string> = {
  deposit: "Anzahlung",
  prepayment: "Vorauszahlung",
  final: "Restzahlung",
  full: "Zahlung",
};

export function zahlungsartLabel(type: string | null | undefined, amountCents: number | null | undefined, totalCents: number | null | undefined): string {
  const t = type ?? "";
  if (t === "deposit" && deckteGesamtbetrag(amountCents, totalCents)) return "Zahlung";
  return LABEL[t] ?? t;
}
